// Festival calendar: pure data + a tiny resolver. Dates are compared in IST so every visitor
// sees the same theme on the same day.
//
//   yearly:  ['MM-DD','MM-DD']                   fixed Gregorian dates, repeat every year (wraps over new year)
//   windows: [['YYYY-MM-DD','YYYY-MM-DD'], ...]   lunar festivals; add next year's dates once a year
//
// Each window = lead-up days + the whole festival, inclusive. Overlaps: higher `priority` wins (default 5).
// Eid / Bakrid depend on moon sighting and can move by a day, so they carry one extra day at the end.

export const COVERS_UNTIL = '2027-12-31'; // extend `windows` before this date passes

export const FESTIVALS = [
  // ── fixed dates ──
  { id: 'winter',      priority: 1, yearly: ['12-15', '01-15'] },
  { id: 'christmas',   priority: 6, yearly: ['12-20', '12-26'] },
  { id: 'newyear',     priority: 6, yearly: ['12-28', '01-02'] },
  { id: 'republic',    priority: 8, yearly: ['01-23', '01-26'] },
  { id: 'independence', priority: 8, yearly: ['08-12', '08-15'] },

  // ── lunar / solar-calendar festivals ──
  { id: 'sankranti',      windows: [['2027-01-10', '2027-01-17']] },  // Lohri 13, Sankranti 14/15, Pongal 15-17
  { id: 'vasantpanchami', windows: [['2027-02-07', '2027-02-11']] },
  { id: 'shivratri',      windows: [['2027-03-02', '2027-03-06']] },
  { id: 'eid',            windows: [['2027-03-07', '2027-03-11']] },  // Eid ul-Fitr ~Mar 10 (moon)
  { id: 'holi',           priority: 10, windows: [['2027-03-17', '2027-03-23']] },
  { id: 'ugadi',          windows: [['2027-04-03', '2027-04-08']] },  // Ugadi / Gudi Padwa Apr 7
  { id: 'vishu',          windows: [['2027-04-11', '2027-04-15']] },  // Baisakhi / Vishu / Puthandu / Bihu Apr 14
  { id: 'bakrid',         windows: [['2027-05-13', '2027-05-18']] },  // Eid ul-Adha ~May 17 (moon)
  { id: 'rathyatra',      windows: [['2027-07-01', '2027-07-06']] },
  { id: 'rakhi',          windows: [['2026-10-21', '2027-08-17']] },
  { id: 'janmashtami',    windows: [['2027-08-21', '2027-08-26']] },
  { id: 'ganesh',         priority: 10, windows: [['2027-08-31', '2027-09-14']] }, // Chaturthi Sep 4, Visarjan Sep 14
  { id: 'onam',           priority: 9,  windows: [['2026-10-21', '2027-10-09']] }, // overlaps Ganesh: Ganesh wins
  { id: 'navratri',       priority: 10, windows: [['2026-11-21', '2027-10-09']] }, // Navratri Sep 30 - Dussehra Oct 9
  {
    id: 'diwali',
    priority: 10,
    windows: [
      ['2026-10-25', '2026-11-10'], // Dhanteras Nov 6, Lakshmi Puja Nov 8, Bhai Dooj Nov 10    ['2026-11-01', '2026-11-10']
      ['2027-10-22', '2027-10-31'], // Lakshmi Puja Oct 29, Bhai Dooj Oct 31
    ],
  },
  {
    id: 'gurpurab',
    windows: [
      ['2026-11-21', '2026-11-25'], // Guru Nanak Jayanti Nov 24
      ['2027-11-11', '2027-11-15'], // Nov 14
    ],
  },
];

const IST = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
});

const isActive = (f, ymd) => {
  if (f.windows?.some(([a, b]) => ymd >= a && ymd <= b)) return true;
  if (f.yearly) {
    const md = ymd.slice(5);
    const [a, b] = f.yearly;
    return a <= b ? md >= a && md <= b : md >= a || md <= b;
  }
  return false;
};

export function resolveFestival() {
  // Preview any theme any day: yoursite.in/?festival=holi
  const forced = new URLSearchParams(window.location.search).get('festival');
  if (forced) return FESTIVALS.find((f) => f.id === forced) || null;

  const today = IST.format(new Date()); // "YYYY-MM-DD"
  if (import.meta.env?.DEV && today > COVERS_UNTIL) {
    console.warn('[festival] schedule.js has no dates past', COVERS_UNTIL, '- add next year');
  }
  let best = null;
  for (const f of FESTIVALS) {
    if (isActive(f, today) && (!best || (f.priority ?? 5) > (best.priority ?? 5))) best = f;
  }
  return best;
}
